module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-mv-image-2-f1c00d3aeb23ccad48a30608fe50bae4.png";